<template>
    <label :for="field.name">{{ field.labelGroup || field.label }}</label>
</template>

<script>
   export default {
       name: 'Label',
       props: {
           field: {
               type: Object,
               required: true
           }
       }
   }
</script>